import { SxProps, Theme } from "@mui/material";

const getStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    flex: "1 1 auto",
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      p: "var(--rhythm)",
    },
  },

  image: {
    mb: "calc(2 * var(--rhythm))",
  },

  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "calc(2 * var(--rhythm))",
    mb: "var(--rhythm)",
    [theme.breakpoints.down("md")]: {
      justifyContent: "space-between",
      gap: 0,
    }
  },

  title: {
  },

  assistant: {
    height: "auto !important",
    minHeight: "auto",
    p: "calc(0.25 * var(--rhythm)) calc(0.5 * var(--rhythm))",
  },

  wrapper: {
    display: "flex",
    alignContent: "space-between",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    paddingX: "calc(2 * var(--rhythm))",
    paddingY: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      marginX: "calc(-1 * var(--rhythm))",
      padding: "var(--rhythm)",
      borderRadius: 0,
    },
  },

  custom: {
    mt: "calc(1.5 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      mt: "var(--rhythm)",
    },
  },

  classes: {
    flexDirection: "column",
    alignItems: "center",
    alignContent: "space-between",
    justifyContent: "center",
    gap: "calc(2 * var(--rhythm))",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      gap: "var(--rhythm)",
    },
  },

  actions: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    mt: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      mt: "var(--rhythm)",
      justifyContent: "center",
    },
  },

  borders: {
    display: "flex",
    flexDirection: "row",
    // gap: "calc(2 * var(--rhythm))",
    gap: "var(--rhythm)",
    // mt: "calc(2 * var(--rhythm))",
    mt: "var(--rhythm)",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
      gap: "var(--rhythm)",
      mt: "var(--rhythm)",
      marginX: "calc(-1 * var(--rhythm))",
      borderRadius: 0,
    },
  },
});

export default getStyles;
